import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";

var config = {
  apiKey: "AIzaSyDmxt-hBUz4AVvcyiNmrqcbnpWrDSAOl54",
  authDomain: "react-slack-clone-93c1a.firebaseapp.com",
  databaseURL: "https://react-slack-clone-93c1a.firebaseio.com",
  projectId: "react-slack-clone-93c1a",
  storageBucket: "react-slack-clone-93c1a.appspot.com",
  messagingSenderId: "583184244204"
};

firebase.initializeApp(config);

export default firebase;
